// Shared across pre-auth flows (signup, password reset) that call the backend directly via axios,
// bypassing api/api.ts's authenticated client and its dynamic tenant resolution.
export const getPlatformApiBase = (): string => import.meta.env.VITE_BACKEND_URL ?? '/medendo/api'
